export const getTimerSwitch = (state) => state.timerSwitch.timer;